import { ViewLayout } from "../ViewLayout.tsx";
import { BrandColorSection } from "./BrandColorSection.tsx";
import { BrandFontSection } from "./BrandFontSection.tsx";
import { BrandLogoSection } from "./BrandLogoSection.tsx";

export const BrandKitView = () => (
  <ViewLayout title="Brand Kit">
    <div className="flex-col gap-800">
      <BrandLogoSection />
      <BrandColorSection />
      <BrandFontSection />
    </div>
  </ViewLayout>
);
